import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CheckoutFacade } from '../facades/checkout.facade';
import { mergeMap, Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { CheckoutActions } from '../actions';
import { IRfqHistory } from '../models/rfq.models';

@Injectable({
  providedIn: 'root',
})
export class CheckoutEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly checkoutFacade: CheckoutFacade = inject(CheckoutFacade);

  readonly GetOrdersHistoryData$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckoutActions.GetQuoteRfqHistoryStartDataAction),
      mergeMap(
        () => this.checkoutFacade.getQuoteHistory()
          .pipe(
            map((data: IRfqHistory) =>
              CheckoutActions.SuccessGetQuoteRfqHistoryDataAction({
                rfqBaseInfo: data,
              }),
            ),
          ),
      ),
    ));
}
